<template>
  <div>
    <v-client-table :data="faces"
                    :columns="columns"
                    :options="options"
                    class="infoWindowMapTable">
      <div slot="affectations" slot-scope="props">
        <div :key="index" v-for="(affectation, index) in props.row.affectations">
          <div v-if="affectation.dateStart">{{affectation.annonceur}}
            (du {{affectation.dateStart}} au {{affectation.dateEnd}} )</div>
        </div>
      </div>
      <div slot="affectationsReseaux" slot-scope="props">
        <div :key="index" v-for="(affectation, index)
                 in props.row.affectationsReseaux">
          <div v-if="affectation.dateStart">{{affectation.resLibelle}}
            (du {{affectation.dateStart}} au {{affectation.dateEnd}} )</div>
        </div>
      </div>
      <div slot="selected" slot-scope="props">
        <button class="button is-pulled-right"
                v-bind:class="{ 'is-primary': !props.row.selected,
                                    'is-danger': props.row.selected }"
                @click="ajoutPanier(props.row)">
          <b-icon icon="cart-off" v-if="props.row.selected"></b-icon>
          <b-icon icon="cart-plus" v-if="!props.row.selected"></b-icon>
        </button>
      </div>
      <div slot="Disponibilite" slot-scope="props"
           class="image is-36x36 button noHandCursor centrer_disponibilite"
           v-bind:class="props.row.dispoClass">
      </div>
      <div slot="Historique">
        <a class="plusInfo" @click="isOpenHistorique = true">
          Voir plus
        </a>
      </div>
    </v-client-table>
    <b-modal v-model="isOpenHistorique"
               destroy-on-hide
               @hide="closeHistorique()"
               >
        <historique :face="face"/>
    </b-modal>
  </div>

</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import moment from 'moment';
import { TEXTS, RESULTS_PER_PAGE, PER_PAGE_VALUE } from '@/configuration/clientTableConf';
import faceSelectedInitialise from '@/services/catalogue/faceSelectedInitializer';
import * as niveauDispo from '@/components/creationOpportunite/configuration/DisponibiliteConf';
import gestionErreur from '@/services/general/gestionErreur';
import { columnsSplice } from '@/services/general/columns';
import Historique from './historique';

const VenteFacesLc = createNamespacedHelpers('venteFacesLc');
const Panier = createNamespacedHelpers('panier');
const Parametrages = createNamespacedHelpers('parametrage');

export default {
  name: 'liste-affectations',
  props: ['panneau'],
  components: {
    Historique,
  },
  data() {
    return {
      trad: {
        facCode: 'Face',
        affectations: 'Affectations LC',
        affectationsReseaux: 'Affectations Réseaux',
        selected: '',
        Disponibilite: 'Dispo',
        Historique: 'Historique',
      },
      isOpenHistorique: false,

    };
  },
  computed: {
    ...VenteFacesLc.mapGetters({
      dateStart: 'dateStart',
      dateEnd: 'dateEnd',
    }),
    ...Panier.mapGetters({
      panneauxLcPanier: 'panneauxLcPanier',
    }),
    ...Parametrages.mapGetters({
      isAffixe2: 'affixe2',
    }),
    faces: {
      get() {
        const faces = [];
        this.panneau.panneauOrigine.faces.forEach((el) => {
          const face = {
            facCode: el.facCode,
            affectations: [],
            affectationsReseaux: [],
            panNum: this.panneau.panneauOrigine.num,
            facNum: el.facNum,
            urlPhoto: el.urlPhoto,
            dispoClass: niveauDispo.CLASS_NIVEAU_DISPONIBILITE[el.niveauDisponibilite],
            panCode: this.panneau.namePlace,
          };
          el.affectations.forEach((affectation) => {
            if (moment(affectation.dateDebut) <= moment(this.dateEnd)
              && moment(affectation.dateFin) >= moment(this.dateStart)) {
              const dateStart = moment(affectation.dateDebut).format('DD/MM/YYYY');
              const dateEnd = moment(affectation.dateFin).format('DD/MM/YYYY');
              face.affectations.push({ annonceur: affectation.annonceur,
                dateStart: dateStart,
                dateEnd: dateEnd });
            }
          });
          el.affectationsReseaux.forEach((affectation) => {
            if (moment(affectation.dateDebut) <= moment(this.dateEnd)
              && (moment(affectation.dateFin) >= moment(this.dateStart) || !affectation.dateFin)) {
              const dateStart = moment(affectation.dateDebut).format('DD/MM/YYYY');
              const dateEnd = affectation.dateFin ? moment(affectation.dateFin).format('DD/MM/YYYY') : null;
              face.affectationsReseaux.push({ resLibelle: affectation.resLibelle,
                dateStart: dateStart,
                dateEnd: dateEnd });
            }
          });
          faces.push(face);
        });
        faceSelectedInitialise(faces, this.panneauxLcPanier);
        faces.sort((a, b) => {
          if (a.facCode < b.facCode) return -1;
          else if (a.facCode === b.facCode) return 0;
          return 1;
        });
        return faces;
      },
    },
    face: {
      get() {
        let face = null;
        this.panneau.panneauOrigine.faces.forEach((el) => {
          const fac = {
            facCode: el.facCode,
            panNum: this.panneau.panneauOrigine.num,
            facNum: el.facNum,
            urlPhoto: el.urlPhoto,
            dispoClass: niveauDispo.CLASS_NIVEAU_DISPONIBILITE[el.niveauDisponibilite],
            panCode: this.panneau.namePlace,
          };
          face = fac;
        });
        return face;
      },
    },
    columns() {
      const columns = ['selected', 'Disponibilite', 'facCode', 'affectations', 'affectationsReseaux', 'Historique'];
      if (!this.isAffixe2) columnsSplice(columns, 'Historique');
      return columns;
    },
    options() {
      return {
        headings: {
          facCode: this.trad.facCode,
          affectations: this.trad.affectations,
          affectationsReseaux: this.trad.affectationsReseaux,
          selected: this.trad.selected,
          Disponibilite: this.trad.Disponibilite,
          Historique: this.trad.Historique,
        },
        filterable: false,
        perPageValues: PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        texts: TEXTS,
        columnsClasses: {
          selected: 'iconesModalAffectationVenteLc',
          Disponibilite: 'iconesModalAffectationVenteLc',
        },
      };
    },
  },
  methods: {
    ...VenteFacesLc.mapActions({
      actionsGestionPanier: 'gestionPanier',
    }),
    async ajoutPanier(f) {
      const loadingComponent = this.$buefy.loading.open({ container: this.$el });
      try {
        await this.actionsGestionPanier({ face: f });
        loadingComponent.close();
      } catch (e) {
        gestionErreur(e.message, e);
        loadingComponent.close();
      }
    },
    closeHistorique() {
      this.isOpenHistorique = false;
      this.face = null;
    },
  },
};
</script>

<style>
  .iconesModalAffectationVenteLc {
    width: 60px;
  }
</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/venteFacesLc/recherche/cartographie/listeAffectations.vue